module.exports = __webpack_public_path__ + "files/e64fd5a7ee26b837c6bc76863390890a.png";